import EcocardioDatiEdit from "./components/EcocardioDatiEdit.vue";
import EcocardioDatiView from "./components/EcocardioDatiView.vue";
import EcocardioDatiList from "./components/EcocardioDatiList.vue";

export default {
    EcocardioDatiEdit,
    EcocardioDatiView,
    EcocardioDatiList,
};
